/* Nesti — produto das seções portadas do GemPages (substitui gp-product, gp-product-variants,
   gp-product-images, gp-product-price/tag, gp-product-button e gp-accordion do runtime do app).
   Os dados vêm do Liquid (<script data-nesti-gp-produto>): variantes da loja + slide de cada variante. */
(function () {
  function moeda(centavos) {
    var cod = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cod }).format(centavos / 100); }
    catch (e) { return '£' + (centavos / 100).toFixed(2); }
  }

  /* ───────── variantes ───────── */
  function iniciarProduto(el) {
    if (el.dataset.nestiPronto) return;
    el.dataset.nestiPronto = '1';
    var dados = {};
    try { dados = JSON.parse((el.querySelector('script[data-nesti-gp-produto]') || {}).textContent || '{}'); } catch (e) {}
    var produto = dados.produto || {};
    var variantes = produto.variants || [];
    dados.opcoes = produto.options || [];
    var form = el.querySelector('form[action*="/cart/add"]');
    var campoId = form && form.querySelector('input[name="id"]');
    var grupos = Array.prototype.slice.call(el.querySelectorAll('.variant-option-group'));
    // estilo do botão escolhido e do não escolhido, lido do próprio desenho (o app aplicava inline)
    var moldes = grupos.map(function (g) {
      var ativo = g.querySelector('label.option-item-active') || g.querySelector('label.option-item');
      var outro = Array.prototype.find.call(g.querySelectorAll('label.option-item'), function (l) { return l !== ativo; });
      function estilos(l) {
        if (!l) return null;
        return ['.option-value-wrapper', '.option-value'].map(function (s) { var x = l.querySelector(s); return x ? x.getAttribute('style') : null; });
      }
      return { ativo: estilos(ativo), inativo: estilos(outro) };
    });
    function marcar(g, k, label) {
      var m = moldes[k];
      g.querySelectorAll('label.option-item').forEach(function (l) {
        var sim = l === label;
        l.classList.toggle('option-item-active', sim);
        var inp = l.querySelector('input[type=radio]');
        if (inp) { inp.checked = sim; inp.setAttribute('checked', sim ? 'true' : 'false'); }
        var est = sim ? m.ativo : m.inativo;
        if (!est) return;
        ['.option-value-wrapper', '.option-value'].forEach(function (s, i) {
          var x = l.querySelector(s);
          if (x && est[i] != null) x.setAttribute('style', est[i]);
        });
      });
      // "Size: Small Kids" — o valor escolhido ao lado do nome da opção
      var bloco = g.parentElement;
      var legenda = bloco && bloco.querySelector('legend.variant-display span');
      if (legenda && label) legenda.textContent = (label.querySelector('input') || {}).value || legenda.textContent;
    }
    function escolhidas() {
      return grupos.map(function (g) {
        var l = g.querySelector('label.option-item-active');
        return l ? (l.querySelector('input') || {}).value : null;
      });
    }
    function achar(vals) {
      var nomes = grupos.map(function (g) { return g.getAttribute('variant-option-name'); });
      return variantes.find(function (v) {
        return nomes.every(function (n, i) {
          var pos = (dados.opcoes || []).indexOf(n);
          return pos < 0 || v.options[pos] === vals[i];
        });
      });
    }
    function aplicar(v, doUsuario) {
      if (!v) return;
      if (campoId) campoId.value = v.id;
      el.querySelectorAll('.gp-price.gp-money:not(.gp-product-compare-price)').forEach(function (p) { p.textContent = moeda(v.price); });
      el.querySelectorAll('.gp-product-compare-price').forEach(function (p) {
        p.textContent = v.compare_at_price > v.price ? moeda(v.compare_at_price) : '';
      });
      el.querySelectorAll('[data-nesti-economia]').forEach(function (t) {
        var dif = (v.compare_at_price || 0) - v.price;
        t.textContent = (t.getAttribute('data-nesti-economia') || 'Save {v}').replace('{v}', moeda(Math.max(dif, 0)));
        var tag = t.closest('gp-product-tag'); if (tag) tag.style.display = dif > 0 ? '' : 'none';
      });
      var comprar = el.querySelector('button[name="add"]');
      var esgotado = el.querySelector('button[data-id$="-sold-out"]');
      // o app mostra um botão ou o outro pelo invólucro (<div class="!gp-hidden"> dentro do gp-button):
      // esgotado = some o ADD TO CART e aparece o "Out Of Stock"
      function mostrar(b, sim) { var w = b.parentElement; if (w && w.parentElement && w.parentElement.tagName === 'GP-BUTTON') w.classList.toggle('!gp-hidden', !sim); }
      if (comprar) { comprar.setAttribute('gp-data-hidden', v.available ? 'false' : 'true'); comprar.disabled = !v.available; mostrar(comprar, v.available); }
      if (esgotado) { esgotado.setAttribute('gp-data-hidden', v.available ? 'true' : 'false'); mostrar(esgotado, !v.available); }
      if (doUsuario && dados.slides && dados.slides[v.title] != null) irParaSlide(el, dados.slides[v.title]);
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      if (doUsuario) history.replaceState(history.state, '', u.toString());
      el.dispatchEvent(new CustomEvent('nesti:variante', { bubbles: true, detail: { variante: v } }));
    }
    grupos.forEach(function (g, k) {
      g.addEventListener('click', function (ev) {
        var label = ev.target.closest('label.option-item');
        if (!label || !g.contains(label)) return;
        ev.preventDefault();
        marcar(g, k, label);
        aplicar(achar(escolhidas()), true);
      });
    });
    // variante vinda na URL (?variant=) escolhe os botões certos
    var inicial = variantes.find(function (v) { return String(v.id) === String(campoId && campoId.value); });
    if (inicial) {
      grupos.forEach(function (g, k) {
        var pos = (dados.opcoes || []).indexOf(g.getAttribute('variant-option-name'));
        var alvo = Array.prototype.find.call(g.querySelectorAll('label.option-item'), function (l) {
          return (l.querySelector('input') || {}).value === inicial.options[pos];
        });
        if (alvo && !alvo.classList.contains('option-item-active')) marcar(g, k, alvo);
      });
      aplicar(inicial, false);
    }
  }

  /* ───────── galeria: miniatura -> foto grande, e a moldura da miniatura acompanha ───────── */
  function destaque(el) { return el.querySelector('gp-carousel[type="gp-feature-image-carousel"]'); }
  function irParaSlide(el, i) {
    var c = destaque(el);
    if (c && c.nestiIr) c.nestiIr(i);
  }
  function iniciarGaleria(el) {
    var c = destaque(el);
    var galeria = el.querySelector('.gp-product-images-gallery');
    if (!c || !galeria || galeria.dataset.nestiPronto) return;
    galeria.dataset.nestiPronto = '1';
    var itensG = Array.prototype.slice.call(galeria.querySelectorAll('.gem-slider-item[id]'));
    function indiceDoDestaque(midia) {
      var itens = c.nestiItens || c.querySelectorAll('.gem-slider-item');
      for (var i = 0; i < itens.length; i++) if (itens[i].id && itens[i].id.slice(-String(midia).length - 1) === '-' + midia) return i;
      return -1;
    }
    itensG.forEach(function (it) {
      it.addEventListener('click', function (ev) {
        ev.preventDefault();
        var i = indiceDoDestaque(it.id);
        if (i >= 0) irParaSlide(el, i);
      });
    });
    c.addEventListener('nesti:slide', function (ev) {
      var item = ev.detail.item; if (!item) return;
      var midia = item.id.split('-').pop();
      itensG.forEach(function (it) { it.setAttribute('data-outline', it.id === midia ? 'active' : 'deactive'); });
    });
  }

  /* ───────── sanfona (gp-accordion): a mesma regra do app ───────── */
  function iniciarSanfona(ac) {
    if (ac.dataset.nestiPronto) return;
    ac.dataset.nestiPronto = '1';
    var cfg = {};
    try { cfg = JSON.parse(ac.getAttribute('gp-data') || '{}').setting || {}; } catch (e) {}
    var unica = cfg.expandedMode !== 'multiple';
    var itens = Array.prototype.filter.call(ac.querySelectorAll('.gp-accordion-item'), function (it) { return it.closest('gp-accordion') === ac; });
    function icone(it, aberto) {
      var ic = it.querySelector('.gp-collapsible-icon'); if (!ic) return;
      var svg = aberto ? (cfg.iconExpand || cfg.iconSvg) : (cfg.iconCollapse || cfg.iconSvg);
      if (svg) ic.innerHTML = svg;
      if (aberto && cfg.iconExpand) { ic.classList.remove('gp-rotate-90', '-gp-rotate-90'); }
      if (!aberto && !cfg.iconCollapse) { ic.classList.add('gp-rotate-90'); }
    }
    function abrir(it, sim) {
      var corpo = it.querySelector('.gp-accordion-item_body'); if (!corpo) return;
      if (sim) {
        corpo.style.gridTemplateRows = 'unset';
        corpo.style.maxHeight = corpo.scrollHeight + 'px';
        corpo.dataset.show = 'true';
        corpo.addEventListener('transitionend', function f() { corpo.removeEventListener('transitionend', f); if (corpo.dataset.show === 'true') corpo.style.maxHeight = ''; });
      } else {
        corpo.style.maxHeight = corpo.scrollHeight + 'px';
        void corpo.offsetHeight;
        corpo.style.maxHeight = '0px';
        delete corpo.dataset.show;
      }
      icone(it, sim);
    }
    itens.forEach(function (it) {
      var cab = it.querySelector('.gp-accordion-item_header');
      if (!cab) return;
      cab.addEventListener('click', function (ev) {
        ev.preventDefault();
        var corpo = it.querySelector('.gp-accordion-item_body');
        var aberto = corpo && corpo.dataset.show === 'true';
        if (!aberto && unica) itens.forEach(function (o) { if (o !== it) { var c2 = o.querySelector('.gp-accordion-item_body'); if (c2 && c2.dataset.show === 'true') abrir(o, false); } });
        abrir(it, !aberto);
      });
    });
  }

  /* selo de estrelas (Lai): leva até a grade de avaliações da página */
  document.addEventListener('click', function (ev) {
    var s = ev.target.closest && ev.target.closest('[data-nesti-ir-avaliacoes]');
    if (!s) return;
    var alvo = document.getElementById('nesti-avaliacoes');
    if (alvo) { ev.preventDefault(); alvo.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  function tudo() {
    document.querySelectorAll('gp-product').forEach(function (el) { iniciarProduto(el); iniciarGaleria(el); });
    document.querySelectorAll('gp-accordion').forEach(iniciarSanfona);
  }
  // o carrossel (nesti-gp.js) precisa existir antes da galeria ligar nele
  function quandoPronto() { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(tudo, 0); }); else setTimeout(tudo, 0); }
  quandoPronto();
  document.addEventListener('shopify:section:load', tudo);
})();
